module.exports = __webpack_public_path__ + "img/rascrut-10.4385690f.jpg";